import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { digitalEngagementDataSource } from 'infrastructure/data-sources/digital-engagement';

import type { IDigitalEngagementItem } from 'infrastructure/data-sources/digital-engagement';
import type { IBaseSelectBoxProps } from 'components/atoms/base-select-box/types';

interface IDigitalEngagementSelectBoxProps<N extends boolean>
  extends Omit<
    IBaseSelectBoxProps<IDigitalEngagementItem<N>['id']>,
    'options'
  > {
  withNull: N;
  value?: IDigitalEngagementItem<N>['id'];
  onChange: (value: IDigitalEngagementItem<N>['id']) => void;
}

const DigitalEngagementSelectBox = <N extends boolean>({
  withNull,
  ...props
}: IDigitalEngagementSelectBoxProps<N>) => {
  const dataSource = useMemo(
    () => digitalEngagementDataSource(withNull),
    [withNull],
  );

  const options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} useUndefinedValue />;
};

export default DigitalEngagementSelectBox;
